// extracted by mini-css-extract-plugin
module.exports =  {"root":"c4dU1d","isMobile":"d2JQjp"};